export default {
  default_browser_tag: 'FoodAmigos - Zamów online',
  seo: {
    title: '{{name}} – zamów jedzenie online w {{city}}',
    description: '{{name}} w {{city}}. Oficjalne menu. Oszczędzaj i zamawiaj online.',
  },
};
